module.exports = __webpack_public_path__ + "static/media/bv-logo-coloured.fe8407da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bv-logo-coloured.svg
// module id = 1655
// module chunks = 20